export default __webpack_public_path__ + "static/media/me3_GreenCheckMark.4bed2abb.svg";